<template>

  <div class="bg position-relative">
    <div class="background-top">
      <div class="bc">
        <div style="height: 60px;"/>
        <img class="img_1" src="/img/image/home/t_5.png" loading="lazy" alt="要烤出一條脆皮豬 要經過多少工序？"/>
        <div style="height: 45px;"/>
        <Glide :glide-item-type="glideItemType" :htmlArray="htmlArray"/>
        <div class="space_1"/>
        <div class="text-center">
          <img class="img_2" src="/img/image/home/t_6.png" loading="lazy" alt="32小時精心淬煉 只為那一口多汁酥脆"/>
        </div>
        <div class="space_2"/>
      </div>
    </div>
    <div class="background-bottom">
      <div class="bc">
        <div class="space_3"/>
        <img class="img_3" src="/img/image/home/t_7.png" loading="lazy" alt="每一口都是對品質的堅持"/>
      </div>
    </div>
  </div>


</template>

<script>
import * as GlideItemType from '../../shared/glide_item_type'
import Glide from "../../components/Glide";

export default {
  name: "Stage_2",
  components: {Glide},
  computed: {
    glideItemType() {
      return GlideItemType.roastedPork;
    },
  },
  data() {
    return {
      htmlArray: [
        {
          imgUrl: "/img/image/home/herbal_img.png",
          iconUrl: "/img/image/icon/herbal_icon.png",
          info: "調味使用<span class='point'>34種中式天然辛香料</span>"
        },
        {
          imgUrl: "/img/image/home/machine_img.png",
          iconUrl: "/img/image/icon/machine_icon.png",
          info: "肉質經過<span class='point'>大型按摩機</span>按摩數時，使肉質更加鮮嫩入味"
        },
        {
          imgUrl: "/img/image/home/meat_img.png",
          iconUrl: "/img/image/icon/meat_icon.png",
          info: "<span class='point'>低溫風乾15小時</span>，風乾後立即真空，乾淨衛生\n"
        },
        {
          imgUrl: "/img/image/home/truck_img.png",
          iconUrl: "/img/image/icon/truck_icon.png",
          info: "<span class='point'>全程低溫配送</span>至各店，堅持維持最好品質"
        },
        {
          imgUrl: "/img/image/home/bake_img.png",
          iconUrl: "/img/image/icon/bake_icon.png",
          info: `各店<span class="point">現場烤爐烘烤</span>長達1小時20分鐘，只呈現現烤美味`
        },
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.bg {
  max-height: 1825px;
}

@media (max-width: 576px) {
  .bg {
    text-align: center;
  }
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
}


.background-top, .background-bottom {
  background-size: cover;
  background-position: center;
  width: 100%;
}

.background-top {
  background-image: url('/img/image/background/bg_s3.png');
  height: auto;
}

.background-bottom {
  background-image: url('/img/image/background/bg_s4.png');
  height: 795px;
}

@media (max-width: 576px) {
  .background-bottom {
    height: auto;
  }
}

//文字 要烤出一條脆皮豬 要經過多少工序？
.img_1 {
  padding-left: 87px;
  width: 615px;
  height: auto;
  object-fit: cover;
}

@media (min-width: 1440px) {
  .img_1 {
    width: 615px;
  }
}

@media (max-width: 992px) {
  .img_1 {
    padding-left: 8vw;
    width: 60vw;
  }
}

@media (max-width: 576px) {
  .img_1 {
    padding-left: 0px;
    width: 320px;
  }
}

@media (max-width: 360px) {
  .img_1 {
    width: 240px;
  }
}


//文字 32小時精心淬煉 只為那一口多汁酥脆
.img_2 {
  max-width: 1173px;
  width: 81vw;
  height: auto;
  object-fit: cover;
  content: url('/img/image/home/t_6.png');
}

@media (min-width: 1440px) {
  .img_2 {
    width: 81vw;
  }
}

@media (max-width: 992px) {
  .img_2 {
    width: 81vw;
  }
}

@media (max-width: 576px) {

  .img_2 {
    visibility: hidden;
    height: 0;
    //content: url('/img/image/home/t_6_2.png');
    //width: 56vw;
  }
}

@media (max-width: 360px) {
  .img_2 {
    //width: 66vw;
  }
}


.space_1 {
  height: 65px;
}

@media (max-width: 576px) {
  .space_1 {
    height: 0px;
  }
}


.space_2 {
  height: 60px;
}

@media (max-width: 576px) {
  .space_2 {
    height: 0px;
  }
}

.space_3 {
  height: 60px;
}

@media (max-width: 576px) {
  .space_3 {
    height: 0px;
  }
}

.img_3 {
  padding-left: 87px;
  width: 640px;
  height: auto;
  object-fit: cover;
}

@media (max-width: 992px) {
  .img_3 {
    width: 64vw;
  }
}

@media (max-width: 576px) {
  .img_3 {
    content: url('/img/image/background/bg_s16.png');
    width: 100%;
    height: auto;
    padding: 0;
    //visibility: hidden;
  }
}


</style>
